/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Container from '../container/container'
import HeaderSearch from '../header-search/header-search'
import { Icon } from '../icon/icon'
import { Link } from '../internal-link/Internal-link'
import LanguageSwitch from '../language-switch/language-switch'
import { getImgSrc } from '~/utils/image'
import { cn } from '~/utils/misc'
import { useOptionalUser } from '~/utils/user'
import { MenuSheet } from './menu-sheet'

export default function Header({ classes }: { classes?: string | undefined }) {
	const [scrollHide, setScrollHide] = useState(true)
	const [lastScrollY, setLastScrollY] = useState(81)
	const [isMenuSheetOpen, setIsMenuSheetOpen] = useState(false)

	const controlNavbar = () => {
		if (window.scrollY > lastScrollY && window.scrollY > 1000) {
			setScrollHide(false)
		} else {
			setScrollHide(true)
		}
		setLastScrollY(window.scrollY)
	}
	const user = useOptionalUser()
	const { t } = useTranslation()

	useEffect(() => {
		window.addEventListener('scroll', controlNavbar)

		// cleanup function
		return () => {
			window.removeEventListener('scroll', controlNavbar)
		}
	}, [lastScrollY])
	return (
		<header
			className={cn(
				'bg-card text-foreground dark:bg-background fixed top-0 z-20 w-full border-b py-4 shadow-xs transition-all delay-150 duration-300',
				classes,
				scrollHide ? 'top-0' : 'top-0 md:top-[-81px]',
			)}
		>
			<Container marginY={false}>
				<nav className="flex items-center justify-between">
					<Link
						to="/"
						className="hidden text-2xl font-extrabold tracking-wide md:block"
					>
						<span className="text-foreground">EVENT</span>
						<span className="text-secondary">
							LY
							{ENV.MODE === 'development' && (
								<sup className="text-foreground ml-2 text-sm font-extrabold">
									<sup>{'<DEV>'}</sup>
								</sup>
							)}
						</span>
					</Link>
					<HeaderSearch />
					<div className="hidden w-min! items-center justify-between gap-2 md:flex">
						<LanguageSwitch />
						<MenuSheet
							isOpen={isMenuSheetOpen}
							onOpenChange={setIsMenuSheetOpen}
							isMobile={false}
							trigger={
								<button
									type="button"
									className="border-secondary bg-background hover:bg-accent hover:text-accent-foreground ring-offset-background focus-visible:ring-ring inline-flex h-10 cursor-pointer items-center justify-center gap-x-6 rounded-full border px-3 pr-1 pl-4 text-sm font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
								>
									<Icon name="menu" className="text-body-md">
										<span className="sr-only">{t('misc_menu')}</span>
									</Icon>
									<div className="bg-muted border-border flex h-8 w-8 shrink-0 items-center justify-center rounded-full border">
										{user ? (
											<img
												className="h-8 w-8 shrink-0 rounded-full object-cover"
												alt={user.name ?? ''}
												src={getImgSrc(user.imageId, 'user')}
												loading="lazy"
											/>
										) : (
											<Icon name="user-group" className="text-body-md" />
										)}
									</div>
								</button>
							}
						/>
					</div>
				</nav>
			</Container>
		</header>
	)
}
